import { Component, OnInit, OnDestroy, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from 'src/services/auth.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Utils } from 'src/services/utils';

@Component({
    selector: "rm-chain-node",
    templateUrl: "./node.component.html",
    styleUrls: ["./node.component.css"]
  })
  export class ChainNodeComponent implements OnInit, OnDestroy {
    roles: any[] = [];
    addedRoles: any[] = [];
    selectedRole: any;
    previousRole: any;

    nodeFormGroup = new FormGroup({
        type: new FormControl(),
        addAfter: new FormControl()
    });

    constructor(
        private dialogRef: MatDialogRef<ChainNodeComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private authService: AuthService,
        private utils: Utils
    ) {
        this.addedRoles = data.addedRoles;
        if (data.data) {
            this.selectedRole = data.data.selectedRole;
            this.previousRole = data.data.previousRole;
        }
    }

    ngOnInit() {

        this.authService.getRoles().subscribe(
            (result: any)=> {
                this.roles = result;
            }
        );

    }

    ngOnDestroy() {

    }

    onSubmit(values) {
        var selectedRole = this.utils.getObject('name', values.type, this.roles);
        values['role'] = selectedRole;
        this.dialogRef.close(values);
    }

  }